var _circle, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsdt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_16087_145893",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_16087_145893)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.06126 5.75H17.1411C17.3816 5.75 17.6038 5.8724 17.7237 6.07097L20.6605 10.9326C20.8127 11.1847 20.7675 11.5029 20.5502 11.7074L12.467 19.3152C12.2051 19.5616 11.7839 19.5616 11.5221 19.3152L3.44975 11.7176C3.22748 11.5084 3.18586 11.1809 3.34931 10.9272L6.48837 6.05537C6.61062 5.86563 6.82756 5.75 7.06126 5.75ZM15.8396 7.92054V9.28462H12.9683V10.2304C14.9849 10.3315 16.4979 10.7466 16.5091 11.2441L16.5091 12.2813C16.4978 12.7789 14.9849 13.194 12.9683 13.2951V15.6161H11.0617V13.2951C9.04504 13.194 7.53203 12.7789 7.5208 12.2813L7.52088 11.2441C7.53209 10.7466 9.04504 10.3315 11.0617 10.2304V9.28462H8.19033V7.92054H15.8396ZM12.015 12.5825C14.1671 12.5825 15.9659 12.2315 16.4061 11.7627C16.0328 11.3652 14.6825 11.0524 12.9683 10.9665V11.9567C12.661 11.9721 12.3421 11.9802 12.015 11.9802C11.6879 11.9802 11.3689 11.9721 11.0617 11.9567V10.9665C9.34743 11.0524 7.99716 11.3652 7.62385 11.7627C8.06407 12.2315 9.86286 12.5825 12.015 12.5825Z",
    fill: "#009393"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/USDT.7190986681bd9c7bcdf60f934bc33406.svg";
export { ForwardRef as ReactComponent };